/**
 * @fileoverview Firebase configuration manager for US and Canada environments
 * Environment Variables Required:
 * - VUE_APP_COUNTRY: 'US' or 'CAN'
 * - NODE_ENV: 'development' or 'production'
 */

/**
 * US Firebase Configuration Object
 * @constant {Object}
 */
const US_CONFIG = {
	apiKey: 'AIzaSyBCykf-y2DE_e_gVjB0eKIfIWuzqN6TZUs',
	authDomain: 'large-account-portal-prod.firebaseapp.com',
	databaseURL:
		process.env.NODE_ENV === 'production'
			? 'https://large-account-portal-prod-default-rtdb.firebaseio.com'
			: 'http://localhost:9000/?ns=large-account-portal-prod',
	projectId: 'large-account-portal-prod',
	storageBucket: 'large-account-portal-prod.appspot.com',
	messagingSenderId: '831305087868',
	appId: '1:831305087868:web:5ac868a31d4044fa27c2f9',
}

/**
 * Canada Firebase Configuration Object
 * @constant {Object}
 */
const CANADA_CONFIG = {
	apiKey: 'AIzaSyBwNqNFPd8UCr9LzODp9r0Es9QTpLZ8PxQ',
	authDomain: 'wcc-national-account-prod.firebaseapp.com',
	databaseURL:
		process.env.NODE_ENV === 'production'
			? 'https://wcc-national-account-prod-default-rtdb.firebaseio.com'
			: 'http://localhost:9000/?ns=wcc-national-account-prod',
	projectId: 'wcc-national-account-prod',
	storageBucket: 'wcc-national-account-prod.appspot.com',
	messagingSenderId: '602096111338',
	appId: '1:602096111338:web:aefe577c528feaf4081193',
}

/**
 * Returns Firebase configuration based on country environment variable
 * @function getFirebaseConfig
 * @returns {Object} Firebase configuration object
 * @throws {Warning} If VUE_APP_COUNTRY is not set
 */
const getFirebaseConfig = () => {
	if (!process.env.VUE_APP_COUNTRY) {
		console.warn('VUE_APP_COUNTRY not set, defaulting to US config')
		return US_CONFIG
	}
	return process.env.VUE_APP_COUNTRY === 'CAN' ? CANADA_CONFIG : US_CONFIG
}

export default getFirebaseConfig()
